import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { api_editVendor } from '../../../api/vendor';
import { toast } from 'react-hot-toast';
import { myToastWarning } from '../../../helpers/myToast';

const TYPE = ['decor', 'video', 'photo', 'partyAccessories'];

const EditVendor = () => {
	const vendor = useLocation().state;
	const [loading, setLoading] = useState<boolean>(false);
	const [name, setName] = useState<string>(vendor?.name || ''); // Initialize with vendor.name if available
	const [location, setLocation] = useState<string>(vendor?.location || ''); // Initialize with vendor.location if available
	const [phoneNumber, setPhoneNumber] = useState<string>(vendor?.phoneNumber || ''); // Initialize with vendor.phoneNumber if available
	const [type, setType] = useState<string>(vendor?.type || ''); // Initialize with vendor.type if available
	const navigate = useNavigate();

	const edit = async () => {
		if (!name) {
			myToastWarning('Please Enter Name');
			return;
		}
		try {
			setLoading(true);
			const payload = {
				name,
				location,
				phoneNumber,
				type,
			};

			const res = await api_editVendor(payload, vendor._id);
			const message = typeof res.message === 'string' ? res.message : 'Success';
			if (res.isSuccess) {
				toast.success(message || 'Vendor updated successfully');
				setTimeout(() => {
					navigate(-1);
				}, 100);
			} else {
				toast.error(message || 'Failed to update vendor');
			}
		} catch (error) {
			console.error('Error editing vendor:', error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyItems: 'center',
				alignItems: 'center',
				flex: 1,
				padding: '40px',
			}}>
			<div className='mb-3'>
				<h3>Edit Vendor</h3>
			</div>

			<div className='mb-3'>
				<label htmlFor='name' className='form-label'>
					Name
				</label>
				<input
					id='name'
					value={name}
					onChange={(e) => setName(e.target.value)}
					style={{ width: '400px' }}
					className='form-control'
					placeholder='Enter name'
				/>
			</div>

			<div className='mb-3'>
				<label htmlFor='location' className='form-label'>
					Location
				</label>
				<input
					id='location'
					value={location}
					onChange={(e) => setLocation(e.target.value)}
					style={{ width: '400px' }}
					className='form-control'
					placeholder='Enter location'
				/>
			</div>

			<div className='mb-3'>
				<label htmlFor='phoneNumber' className='form-label'>
					Phone Number
				</label>
				<input
					id='phoneNumber'
					value={phoneNumber}
					onChange={(e) => setPhoneNumber(e.target.value)}
					style={{ width: '400px' }}
					className='form-control'
					placeholder='Enter phone number'
				/>
			</div>

			<div className='mb-3'>
				<label htmlFor='type' className='form-label'>
					Type
				</label>
				<select
					id='type'
					value={type}
					onChange={(e) => setType(e.target.value)}
					style={{ width: '400px' }}
					className='form-control'>
					<option value=''>Select Type</option>
					{TYPE.map((option) => (
						<option key={option} value={option}>
							{option}
						</option>
					))}
				</select>
			</div>

			<button
				onClick={edit}
				type='button'
				className='btn btn-lg btn-primary'
				disabled={loading}>
				{loading ? 'Loading..' : 'Submit'}
			</button>
		</div>
	);
};

export default EditVendor;
